const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    attribute_value_product_shop_items: {
      type: 'array',
      title: ' ',
      minItems: 1,
      uniqueItems: true,
      items: {
        type: 'object',
        title: '',
        required: [],
        properties: {
          attribute_value_id: {
            type: 'string',
            title: 'ویژگی',
          },
          price_change_value: {
            type: 'number',
            title: 'قیمت',
          },
        },
      },
    },
  },
});

export default schema;
